// import * as RNLocalize from 'react-native-localize'
import i18n from 'i18n-js'
import { DEFAULT_LANGUAGE } from '../common'

let getTranslations

export const fallbackLanguageCode = DEFAULT_LANGUAGE

const i18nTranslate = (key, config) => i18n.t(key, config)

export const setI18nConfig = async lKey => {
  if (!lKey) {
    lKey = i18n.currentLocale()
  }

  const translations = await getTranslations(lKey)

  // set i18n-js config
  i18n.locale = lKey
  i18n.translations = { [lKey]: translations }
}

export const setLocale = async locale => {
  await setI18nConfig(locale)
}

export const translations = () => i18n.translations[i18n.locale]

export const getCurrentLocale = () => i18n.locale // It will be used to define intial language state in reducer.

export const setTranslationService = servicePromise =>
  getTranslations = servicePromise

export default i18nTranslate
